import { Image } from "expo-image";
import React, { useState } from "react";
import { SvgUri } from "react-native-svg";

function isSvgUri(uri: string): boolean {
  const lower = uri.toLowerCase();
  return lower.includes(".svg") || lower.includes("image/svg");
}

type Props = {
  uri: string | null | undefined;
  size: number;
  fallback?: React.ReactNode;
};

/** Remote skill-pathway art — SVG via SvgUri (RN Image cannot render SVG on native). */
export function SkillPathwayThumbnail({ uri, size, fallback = null }: Props) {
  const [failed, setFailed] = useState(false);
  const trimmed = uri?.trim();

  if (!trimmed || failed) {
    return <>{fallback}</>;
  }

  if (isSvgUri(trimmed)) {
    return (
      <SvgUri
        uri={trimmed}
        width={size}
        height={size}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <Image
      source={{ uri: trimmed }}
      style={{ width: size, height: size }}
      contentFit="contain"
      onError={() => setFailed(true)}
    />
  );
}
